function initProductFilter() {
    const weitgts = [];
    const widths = [];

    $('.js-product-card-filter').each((i, e) => {
        const params = $(e).data('filter');
        weitgts.push(params.weight);
        widths.push(params.width);
    });

    $('[name="weight"]').attr('max', Math.max(...weitgts)).val(Math.max(...weitgts));
    $('[name="width"]').attr('max', Math.max(...widths)).val(Math.max(...widths));

    $('.js-product-filter [type="range"]').on('change', (event) => {
        const elem = $(event.currentTarget);
        elem.prev().text(`(${elem.data('which')} ${elem.val()} ${elem.data('unit')})`);
    }).trigger('change');

    $('.js-product-filter :input').on('change', () => {
        // debugger;
        const typePrefix = $('.js-product-filter [name="type_prefix"]:checked').map((i, e) => $(e).val()).get();
        const weight = $('.js-product-filter [name="weight"]').val();
        const width = $('.js-product-filter [name="width"]').val();

        $('.js-product-card-filter').show();
        $('.js-product-card-filter').each((i, e) => {
            const params = $(e).data('filter');

            let hidebytype = false;
            let hidebyweight = false;
            let hidebywidth = false;

            if (typePrefix.length && typePrefix.indexOf(params.type_prefix) === -1) {
                hidebytype = true;
            }

            if (weight.length) {
                hidebyweight = false;
                if (weight <= params.weight) {
                    hidebyweight = true;
                }
            }

            if (width.length) {
                hidebywidth = false;
                if (width <= params.width) {
                    hidebywidth = true;
                }
            }

            if (hidebytype || hidebyweight || hidebywidth) {
                $(e).hide();
            }
        });
    });
}

$(document).ready(() => {
    initProductFilter();
});
